import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {AppState} from '../../../../../store/appState';
import {makeGetVisualRecipient} from '../../../../../store/data/contacts/recipientsSelectors';
import {ChatPrecog} from './chatPrecog';

/*
 * Props.
 */

interface ChatPrecogContainerProps {
  conversation: ConversationModel;
  teammateId: number;
}

/*
 * Selectors.
 */

function getConversation(_state: AppState, props: ChatPrecogContainerProps) {
  return props.conversation;
}

function getTeammateId(_state: AppState, props: ChatPrecogContainerProps) {
  return props.teammateId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ChatPrecogContainerProps>()(() => ({
  recipient: makeGetVisualRecipient(getConversation, getTeammateId, 'chatPrecogContainer'),
}));

export const ChatPrecogContainer = connect(mapStateToProps)(ChatPrecog);
